var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "date-time-list" },
    _vm._l(_vm.posts, function(post) {
      return !post.is_master
        ? _c(
            "li",
            { staticClass: "date-time-item" },
            [
              _c(
                "span",
                { staticClass: "date-time" },
                [
                  _c("span", { staticClass: "date-time-text" }, [
                    _vm._v(_vm._s(_vm.displayPublishDate(post)))
                  ]),
                  _vm._v(" "),
                  _vm.isDateDuplicate(post)
                    ? _c("i", {
                        staticClass:
                          "fas fa-exclamation-circle date-duplicate-icon",
                        attrs: { id: _vm.duplicateDateTooltipId(post) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDateDuplicate(post)
                    ? _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: _vm.duplicateDateTooltipId(post),
                            triggers: "hover"
                          }
                        },
                        [
                          _vm._v(
                            "\n        This date has multiple posts scheduled\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("SocialStatusLabel", {
                attrs: {
                  deliverable: post,
                  today: true,
                  linkicon: true,
                  namespace: _vm.namespace,
                  returnId: _vm.returnId
                }
              })
            ],
            1
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }